var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zM8.6 3.183 6.283 5.5H3.625A.625.625 0 0 0 3 6.125v3.75c0 .345.28.625.625.625h2.658L8.6 12.816a.625.625 0 0 0 1.066-.442V3.626A.625.625 0 0 0 8.6 3.183zm2.359 3.061a.626.626 0 0 0 .246.85c.336.184.545.531.545.906 0 .374-.21.722-.545.906a.626.626 0 0 0 .603 1.096A2.29 2.29 0 0 0 13 8a2.29 2.29 0 0 0-1.192-2.002.627.627 0 0 0-.85.246z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentMarketing);
export default __webpack_public_path__ + "static/media/incident-marketing.ed5a75a970a9bcdba5fa3cb9a349ba4a.svg";
export { ForwardRef as ReactComponent };